<template>
  <div v-if="data" style="  gap: 2px;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;">
    <v-btn rounded :href="data.primary_location.landing_page_url" target="_blank"
      :color="data.primary_location?.is_oa ? 'primary' : 'grey darken-1'" :dark="!data.primary_location?.is_oa"
      class="mr-3">
      <!--      <v-icon left>mdi-web</v-icon>-->
      <template v-if="data.primary_location?.source?.display_name === 'PubMed'">
        PubMed
      </template>
      <template v-else-if="isOaAtPublisher">
        HTML
      </template>
      <template v-else>
        <div>
          <v-icon left>mdi-lock</v-icon>
          HTML
        </div>
      </template>
      <v-icon small class="ml-1">mdi-open-in-new</v-icon>
    </v-btn>

    <v-btn rounded v-if="!pdfUrl && userIsIran && userId && data.doi" style="mt-2" target="_blank" color="primary"
      :href="'http://ws.glibrary.net/p.aspx?url=' + (data.doi) + '&s=' + userUid">
      Request PDF
    </v-btn>



    <!--   PDF anywhere -->
    <v-btn rounded color="primary" :href="pdfUrl" target="_blank" class="" v-if="pdfUrl">
      PDF
    </v-btn>

    <v-btn rounded @click="showAI" color="success" class="mr-3">
      Chat with AI
    </v-btn>

  </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from "vuex";
import { user } from "../store/user.store";

export default {
  name: "Template",
  components: {},
  props: {
    data: Object,

  },
  data() {
    return {
      foo: 42,
      aiClicking: false,
    }
  },
  computed: {
    ...mapGetters([

      "entityType",
    ]),

    ...mapGetters('user', [
      'userId',
      "userIsIran",
      "userUid",
    ]),
    oaUrl() {
      return this.data.open_access.oa_url
    },
    pdfUrl() {
      return this.data.best_oa_location?.pdf_url
    },
    htmlUrl() {
      return this.data.best_oa_location.landing_page_url
    },
    isGreenOa() {
      return this.data.open_access?.oa_status === 'green'
    },
    isOaAtPublisher() {
      return this.data.open_access?.is_oa && this.data.open_access?.oa_status !== 'green'
    },


  },

  methods: {
    showAI() {
      const path = this.$route.path; // مثلاً "/works/w3128646645"
      const match = path.match(/^\/works\/([^/]+)$/); // گرفتن قسمت دینامیک

      if (match) {
        const workId = match[1]; // یعنی w3128646645
        this.$router.push(`/works?zoom=${workId}`);
      } else {
        const launcher = document.querySelector('.sc-launcher');
        if (launcher) {
          const hasOpened = launcher.classList.contains('opened');
          this.aiClicking = true;

          if (hasOpened) {
            launcher.click();
            setTimeout(() => {
              launcher.click();
              this.aiClicking = false;
            }, 200);
          } else {
            launcher.click();
            this.aiClicking = false;
          }
        }
      }
    },
    ...mapMutations([
      "snackbar",
    ]),
    ...mapActions([]),


  },
  created() {
  },
  mounted() {
  },
  watch: {}
}
</script>

<style scoped lang="scss"></style>
